import React, { useEffect, useState } from 'react';
interface PriceDisplayProps {
  amount: number;
  originalAmount?: number;
  className?: string;
  originalClassName?: string;
  showCurrencyCode?: boolean;
}
export function PriceDisplay({
  amount,
  originalAmount,
  className = 'text-3xl font-bold',
  originalClassName = 'text-lg text-gray-500 line-through decoration-red-500',
  showCurrencyCode = false
}: PriceDisplayProps) {
  const [currency, setCurrency] = useState({
    symbol: '$',
    code: 'USD',
    rate: 1
  });
  useEffect(() => {
    // Simple logic to detect currency based on browser language
    // In a real app, this might use an IP geolocation service
    const detectCurrency = () => {
      const lang = navigator.language || 'en-US';
      if (lang.startsWith('en-GB')) {
        setCurrency({
          symbol: '£',
          code: 'GBP',
          rate: 0.78
        }); // Approx rate
      } else if (['de', 'fr', 'it', 'es-ES', 'pt', 'nl'].some(code => lang.startsWith(code))) {
        setCurrency({
          symbol: '€',
          code: 'EUR',
          rate: 0.92
        }); // Approx rate
      } else {
        // Default to USD for everything else (including LatAm Spanish es-MX, es-CO, etc.)
        setCurrency({
          symbol: '$',
          code: 'USD',
          rate: 1
        });
      }
    };
    detectCurrency();
  }, []);
  // We're not actually converting the price value as per instructions (usually direct response keeps the number psychological e.g. 9.99)
  // But if we needed to, we would multiply amount * currency.rate
  // For this task, we'll keep the number static but change the symbol as requested in the prompt logic:
  // "display the appropriate currency symbol (e.g., $, €, £) next to the price"
  return <div className="flex flex-col items-center justify-center" data-id="element-305">
      {originalAmount && <span className={originalClassName} data-id="element-306">
          {currency.symbol}
          {originalAmount}
          {showCurrencyCode ? ` ${currency.code}` : ''}
        </span>}
      <span className={className} data-id="element-307">
        {currency.symbol}
        {amount}
        {showCurrencyCode ? ` ${currency.code}` : ''}
      </span>
    </div>;
}